import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * 类名合并（shadcn/ui 同款）。clsx 负责条件拼接，tailwind-merge 负责消解冲突
 * —— 例如 `cn('px-2', 'px-4')` 只会留下 `px-4`，这样组件默认样式才能被调用方安全覆盖。
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
